/**
 * Hoji Ritual — navegación por anclas
 *
 * Resuelve dos cosas:
 *  1. Al tocar una opción del menú móvil, el cajón se cierra y la página
 *     hace scroll a la sección (antes el menú se quedaba abierto).
 *  2. Los enlaces tipo "#tienda" funcionan desde CUALQUIER página (producto,
 *     colección, políticas…): si la sección no existe aquí, manda al home
 *     con el ancla.
 */
(function () {
  'use strict';

  var ROOT = (window.hojiRootUrl || '/').replace(/\/+$/, '');

  /* Cierra el cajón móvil reutilizando la lógica de Dawn (limpia el
     trap de foco y el overflow del body). HeaderDrawer.closeMenuDrawer
     se sale si no recibe elementToFocus, así que le pasamos el summary
     con focus sin scroll para que no brinque la página. */
  function closeMobileDrawer(event) {
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    var details = drawer.querySelector('details[open]');
    if (!details) return;

    var summary = details.querySelector('summary');
    if (!summary || typeof drawer.closeMenuDrawer !== 'function') {
      details.removeAttribute('open');
      clearOverlay(details);
      return;
    }

    var nativeFocus = summary.focus;
    summary.focus = function () {
      nativeFocus.call(summary, { preventScroll: true });
    };
    drawer.closeMenuDrawer(event, summary);
    summary.focus = nativeFocus;

    clearOverlay(details);
  }

  /* Dawn solo pone aria-expanded="false" al cerrar con Escape. Si no lo
     limpiamos, la regla .header__icon--menu[aria-expanded='true']::before
     deja la página velada al 50% aunque el cajón ya se haya retraído. */
  function clearOverlay(details) {
    details.querySelectorAll('[aria-expanded="true"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollToTarget(target) {
    var smooth = !(reduceMotion && reduceMotion.matches);
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var link = event.target.closest('a[href]');
    if (!link || link.classList.contains('skip-to-content-link')) return;
    if (link.target && link.target !== '_self') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    var hash = decodeURIComponent(url.hash.slice(1));
    if (!hash) return;

    var target = document.getElementById(hash);

    // Siempre cerramos el cajón: el usuario ya eligió a dónde va.
    closeMobileDrawer(event);

    if (target) {
      event.preventDefault();
      scrollToTarget(target);
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', url.hash);
      }
      return;
    }

    // La sección no vive en esta página: la buscamos en el home.
    if (url.pathname === window.location.pathname) {
      event.preventDefault();
      window.location.href = ROOT + '/' + url.hash;
    }
  });

  /* Al aterrizar en el home con ancla (viniendo de otra página), el salto
     nativo puede quedar mal si las imágenes reacomodan el layout. */
  window.addEventListener('load', function () {
    if (!window.location.hash) return;
    var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (target) scrollToTarget(target);
  });
})();
